import React from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import CloseIcon from "@mui/icons-material/Close";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import "./ReuseableComponent.css";
import Modal from "@mui/material/Modal";
import GCTitleSticky from "./GCTitleSticky";

const GCSimpleSearch = ({
  open,
  xCloseSearchModal,
  xTitle = "",
  xAnyData = "",
  xModelObj,
  xSearchEnter,
  xonChangeInputModal,
  xGridArr,
  xGridDataColumnsSearch,
  xRowClick,
  xClearSimpleSearch,
  xEnterObj,
  xMediaQuery = false,
  xClassName = "model-GCSimpleSearch",
}) => {
  return (
    <Modal
      open={open}
      onClose={xCloseSearchModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={{ flexGrow: 1, overflow: "auto" }} className={xClassName}>
      <GCTitleSticky
        title={xTitle}
        onClose={xCloseSearchModal}
        />
        
        <div className="p-2">
          <Grid container spacing={2} columns={{ xs: 12, sm: 6, md: 12 }}>
            <Grid item xs={3} sm={2} md={2} className="wms-search-label">
              Any Data
            </Grid>
            <Grid item xs={9} sm={4} md={4}>
              <div className="input-group input-group-sm">
                <input
                  autoComplete="off"
                  className="form-control form-control-sm"
                  id="GCSimpleSearch"
                  type="text"
                  name="AnyData"
                  value={xModelObj.AnyData}
                  onChange={xonChangeInputModal}
                  onKeyUp={xSearchEnter}
                />
                {xMediaQuery ? (
                  <span
                    className="input-group-text wms-salse-icon px-2"
                    onClick={(e) => xSearchEnter(xEnterObj)}
                  >
                    <ArrowForwardOutlinedIcon />
                  </span>
                ) : (
                  ""
                )}
              </div>
            </Grid>
            <Grid item xs={3} sm={2} md={2} className="wms-search-label">
              Code
            </Grid>
            <Grid
              item
              xs={9}
              sm={4}
              md={4}
              className="input-group input-group-sm"
            >
              <input
                autoComplete="off"
                className="form-control form-control-sm"
                type="text"
                name="Code"
                value={xModelObj.Code}
                onChange={xonChangeInputModal}
                onKeyUp={xSearchEnter}
              />
              {xMediaQuery ? (
                <span
                  className="input-group-text wms-salse-icon px-2"
                  onClick={(e) => xSearchEnter(xEnterObj)}
                >
                  <ArrowForwardOutlinedIcon />
                </span>
              ) : (
                ""
              )}
            </Grid>
            <Grid item xs={3} sm={2} md={2} className="wms-search-label">
              Name
            </Grid>
            <Grid
              item
              xs={9}
              sm={4}
              md={4}
              className="input-group input-group-sm"
            >
              <input
                autoComplete="off"
                className="form-control form-control-sm"
                type="text"
                name="Name"
                value={xModelObj.Name}
                onChange={xonChangeInputModal}
                onKeyUp={xSearchEnter}
              />
              {xMediaQuery ? (
                <span
                  className="input-group-text wms-salse-icon px-2"
                  onClick={(e) => xSearchEnter(xEnterObj)}
                >
                  <ArrowForwardOutlinedIcon />
                </span>
              ) : (
                ""
              )}
            </Grid>
            <Grid item xs={2} sm={2} md={2}></Grid>
            <Grid item xs={18} sm={4} md={4}>
              <div
                style={{ display: "flex", justifyContent: "space-around" }}
                className="search-btn-sm"
              >
                <button
                  className="btn btn-primary  search-btn"
                  onClick={xClearSimpleSearch}
                >
                  Clear
                </button>
                <button
                  className="btn btn-primary  search-btn"
                  onClick={(e) => {
                    xCloseSearchModal(e);
                    xClearSimpleSearch(e);
                  }}
                >
                  Cancel
                </button>
              </div>
            </Grid>
          </Grid>
          <Grid container spacing={2} className="search-item  ">
            <Grid item xs={12} className=" height-table-scroll" component="div">
              <div
                style={{ height: xMediaQuery ? "40vh" : "60vh", width: "100%" }}
                id="table-main-grid-5"
                className="search-grid-table "
              >
                <Box
                  style={{
                    height: xMediaQuery ? "40vh" : "60vh",
                    width: "100%",
                  }}
                  className="bintransfer-out-grid"
                >
                  <DataGrid
                    rowHeight={30}
                    headerHeight={40}
                    getRowClassName={(params) =>
                      params.indexRelativeToCurrentPage % 2 === 0
                        ? "mui-even-row"
                        : "mui-odd-row"
                    }
                    sx={{
                      border: 1,
                      borderColor: "primary.light",
                    }}
                    rows={xGridArr}
                    columns={xGridDataColumnsSearch}
                    hideFooter={xGridArr.length < 100}
                    onCellKeyDown={(newSelectionModel, e) => {
                      if (e.key === "Enter") {
                        xRowClick(newSelectionModel);
                      }
                    }}
                    onRowClick={xRowClick}
                    components={{
                      Toolbar: GridToolbar,
                    }}
                  />
                </Box>
              </div>
            </Grid>
          </Grid>
        </div>
      </Box>
    </Modal>
  );
};

export default GCSimpleSearch;
